export default __webpack_public_path__ + "static/media/ForgPass.5809a350.svg";